import Lexicon from './Lexicon';
import LexiconLanguage from './LexiconLanguage';

export default class LexiconFactory {

    public static getLexicons(): Lexicon[] {
        return [
            // Thayer
            new Lexicon({
                entryTitleFormatter: entry => 'Thayer',
                id: 'thayer',
                name: 'Thayer\'s Greek English Lexicon of the New Testament'
            }),
            // Middle Liddell
            new Lexicon({
                entryTitleFormatter: entry => 'LiddellM',
                id: 'liddellm',
                name: 'An intermediate Lexicon founded upon the 7th edition of Liddell and Scott\'s Classic'
            }),
            // Strong
            new Lexicon({
                entryTitleFormatter: entry => {
                    return entry.getLanguage() === LexiconLanguage.Hebrew ? `Strongs<br>S${entry.getNumber().replace('L', '')}` : 'Strong'
                },
                id: 'strong',
                name: 'James Strong\'s Concise Hebrew and Greek Bible Dictionary'
            }),
            // Gesenius
            new Lexicon({
                entryTitleFormatter: entry => `Gesenius<br>G${entry.getNumber()}`,
                id: 'gesenius',
                name: 'Gesenius\' Hebrew - Chaldee Lexicon by Samuel Tregelles'
            }),
            // TWOT
            /*new Lexicon({
                entryTitleFormatter: entry => `TWOT<br>T${entry.getNumber()}`,
                id: 'twot',
                name: 'Theological Wordbook of the Old Testament'
            }),*/
            // Lords' Witnesses
            new Lexicon({
                entryTitleFormatter: entry => `LW${entry.getNumber()}`,
                id: 'lw',
                name: 'Lords\' Witnesses'
            }),
            // Big Liddell
            new Lexicon({
                entryTitleFormatter: entry => 'LiddellB',
                id: 'liddellb',
                name: 'Unabridged Liddell-Scott-Jones Greek-English Lexicon'
            }),
            // HALOT
            new Lexicon({
                entryTitleFormatter: entry => `HALOT<br>H${entry.getNumber()}`,
                id: 'halot',
                name: 'HALOT'
            })
        ];
    }
}
